import React from 'react';
import { SectionWithoutDeleteButton } from './Section';
import { connect } from 'react-redux';
import { instructionVersionsDataChanged } from '../actions/instuctionActions';
import deleteSection from './DeleteSection';

function Point({point, versionIndex, dataIndex, disable, dispatch }) {
  const instructionVersionsData = (value, field) => { dispatch(instructionVersionsDataChanged(versionIndex, dataIndex, { ...point, [field]: value }))};


  return <>
    <h1>{point.pointNumber} - <input disabled={disable} type="text" value={point.headerDescription} onChange={e => instructionVersionsData(e.target.value, "headerDescription")}/></h1>
    <SectionWithoutDeleteButton section={point} versionIndex={versionIndex} dataIndex={dataIndex} disable={disable}/>
  </>
}

const mapStateToProps = ({ instructionsReducer }) => {
  return {
    versions: instructionsReducer.versions
  }
}

const mapDispatchToProps = (dispatch) => {
  return { dispatch };
};

export default connect(mapStateToProps, mapDispatchToProps)(deleteSection(Point));
